import { render, staticRenderFns } from "./GenAIUsagePromptLogsTableWidget.vue?vue&type=template&id=b48d34c4&scoped=true&"
import script from "./GenAIUsagePromptLogsTableWidget.vue?vue&type=script&lang=js&"
export * from "./GenAIUsagePromptLogsTableWidget.vue?vue&type=script&lang=js&"
import style0 from "./GenAIUsagePromptLogsTableWidget.vue?vue&type=style&index=0&id=b48d34c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d34c4",
  null
  
)

export default component.exports